import { Injectable } from "@angular/core";
import { BaseViewerService } from "./base-viewer.service";

@Injectable({
  providedIn: "root",
})
export class PhoenixViewerService extends BaseViewerService {}
